import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { storeToRefs } from "pinia";
import { usePiniaState } from "@/store/userPinia";
import { Toast } from "vant";
import { encryptionEditName } from "@/api/php/user";


export default /*#__PURE__*/_defineComponent({
  name: 'LookId',
  setup(__props, { expose }) {
  expose();

const piniaStore = usePiniaState();
const { user, isYk } = storeToRefs(piniaStore);
const { toLogin } = piniaStore;
const router = useRouter();
const route = useRoute();

onMounted(() => {
    toLogin();
});

const id = route.query.id as String;



const __returned__ = { piniaStore, user, isYk, toLogin, router, route, id }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})